import React, {
    useCallback
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {
    ModalNext,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button
} from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './InstitutionDetails.metadata.json5';
import styles from './BankPaymentMethodComponent.module.scss'

function PopulateInstituteDetails({ institutionDetails, onResolve }) {

    const onInstituteSelected = useCallback((selectedRowIndex) => {
        onResolve(institutionDetails[selectedRowIndex]);
    }, [institutionDetails, onResolve]);

    const overrideProps = {
        institutionDetailsDT: {
            data: institutionDetails
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onInstituteSelect: onInstituteSelected
        }
    };

   /* return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );*/

    return (
        renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)
    );
}


function InstitutionDetails({
    institutionDetails, title, isOpen, onResolve
}) {

    const onCancel = useCallback(() => {
        onResolve({});
    }, [onResolve]);

    return (
        <ModalNext isOpen={isOpen} className={styles.modalSize}>
            <ModalHeader title={title} />
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
            >
                <PopulateInstituteDetails institutionDetails={institutionDetails} onResolve={onResolve}/>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onCancel}>
                    Cancel
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

export default InstitutionDetails;
